import useQueryLocation from 'hooks/use-query';

export const useCreateDamageOtpLink = () => {
  const query = useQueryLocation();
  const createDamageOtpCode = query.otp;

  const isAccessCreateDamagePageByOtpLink = !!createDamageOtpCode;

  return { createDamageOtpCode, isAccessCreateDamagePageByOtpLink };
};
